import { RegexIcon } from './RegexIcon';

/**
 * author: Doug C. Hardester
 * id 3313CE4A-E2EF-4E46-8110-C0BF297D0C16
 * name regex
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/regex.svg
 * tags
 */
export const RegularExpressionIcon = RegexIcon;
export default RegularExpressionIcon